import { expected, isDefined } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { useGetTkv2PublicRecordAPI } from '../../../hooks/api/schema-hooks/useGetTkv2PublicRecordAPI.ts';
import { useParsedActiveID } from './useParsedActiveID.ts';

export const usePublicRecordForListing = () => {
  const { orderId: orderID } = useParams();
  const { address } = useParsedActiveID();

  const publicRecord = useGetTkv2PublicRecordAPI(
    {
      pathParams: { orderID: expected(orderID) },
      queryParams: address,
    },
    {
      gcTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: isDefined(address),
    },
  );

  return address ? publicRecord : { isError: true, isLoading: false, data: undefined };
};
